// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD9KMDJSfaQKIQy8S4oBN0UAabDxl-0xuc",
  authDomain: "assignment-10-dec.firebaseapp.com",
  projectId: "assignment-10-dec",
  storageBucket: "assignment-10-dec.appspot.com",
  messagingSenderId: "75228301962",
  appId: "1:75228301962:web:51e55df716f79c96acbb73"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
export default auth;